import * as React from "react";
import { AppBar, IconButton, Toolbar } from "@mui/material";
import { useDispatch } from "react-redux";
import { baseActions } from "../models/BaseSlice";
import LibraryIcon from "@mui/icons-material/LocalLibrary";
import { useCallback, useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import CompareArrowsIcon from "@mui/icons-material/CompareArrows";
import HomeIcon from "@mui/icons-material/Home";
import TopDrawer from "../components/TopDrawer";

import ManageControl from "../../dashboard/containers/ManageControl";
import Api, { APIs } from "../../../Api";
import { setNewsCount } from "../../auth/models/AuthSlice";
import Button from "@mui/material/Button";
import { dialogBoxRef } from "./ContentRouter";
import SROTabs from "../../dashboard/components/sro/SROTabs";
import DocumentMenu from "./DocumentMenu";
import PledgeStatus from "../../dashboard/components/PledgeStatus";
import ADPMenuButton from "./ADPMenuButton";

export const getTodayDate = () => {
  const today = new Date();
  return (
    today.getDate() +
    " " +
    today.toLocaleString("default", { month: "short" }) +
    " " +
    today.getFullYear()
  );
};
const TopAppbar = () => {
  // const [openTopDrawer, setOpenTopDrawer] = React.useState(false);
  const bar1Ref: any = useRef(null);
  const bar2Ref: any = useRef(null);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  // const newsCount = useSelector((state: any) => state.auth.newsCount);
  const [lastUpdateOn, setLastUpdate] = React.useState<string>("");
  const updateAppbarHeight = useCallback(() => {
    const h1 = bar1Ref?.current?.clientHeight || 0;
    const h2 = bar2Ref?.current?.clientHeight || 0;
    // const h3 = this.bar3Ref.current.clientHeight;
    const th = h1 + h2;
    dispatch(baseActions.setTopAppbarHeight(th));
    return th;
  }, [dispatch]);
  window.addEventListener("resize", () => {
    updateAppbarHeight();
  });
  useEffect(() => {
    updateAppbarHeight();
    Api.get(APIs.EAD_NEWS_COUNT).then((payload) => {
      dispatch(setNewsCount(payload));
    });
    Api.get(APIs.MoPD_LAST_UPDATE).then((payload) => {
      if (payload) {
        setLastUpdate(payload);
        dispatch(baseActions.setLatestDate(payload));
      }
    });
  }, [updateAppbarHeight, dispatch]);
  const openProjects = () => {
    navigate("/projects");
  };
  const openPPPProjects = () => {
    navigate("/ppp_projects");
  };
  const openPSDPProjects = () => {
    navigate("/psdp_projects");
  };
  const openADPProjects = (province: string) => {
    navigate(`/adp_projects?province=${province}`);
  };
  const openPledgeStatus = () => {
    dialogBoxRef?.current?.setContent(
      <>
        <PledgeStatus />
      </>,
    );
    dialogBoxRef?.current?.openDialog("Pledge Information (USD in Million)");
  };
  const compareStatsDrawer = () => {
    dispatch(baseActions.setOpenTopDrawer(true));
  };
  const topMargin = 8;
  const buttonTextStyle = {
    marginTop: topMargin,
    marginRight: "10px",
    marginLeft: "5px",
  };
  const buttonIconStyle = { color: "#498c49" };

  return (
    <>
      <AppBar position="static" color="transparent">
        <div
          ref={bar1Ref}
          className="top-nav mb-0 mt-0 pt-0 pb-0 bg-dark"
          style={{
            background:
              "linear-gradient( 180deg, rgb(69.06, 67.62, 67.62) 0%, rgb(78.63, 78.63, 78.63) 100% )",
            boxShadow: "0px 4px 44px #0000001a",
          }}
        >
          <h5 className="pt-1 mb-0" style={{ marginTop: topMargin }}>
            {/*PROJECT MANAGEMENT UNIT R&R (MoPD S&I)*/}
            Recovery and Reconstruction Unit (M/o PD&SI)
          </h5>
          <Toolbar variant="dense">
            <IconButton
              edge="start"
              color="inherit"
              aria-label="projects"
              onClick={() => navigate("/")}
            >
              <HomeIcon sx={buttonIconStyle} />{" "}
              <h5 style={buttonTextStyle}>Home</h5>
            </IconButton>
            {/*<IconButton*/}
            {/*    edge="start"*/}
            {/*    color="inherit"*/}
            {/*    aria-label="projects"*/}
            {/*    onClick={() => navigate("/news")}*/}
            {/*>*/}
            {/*    {newsCount > 0 ?*/}
            {/*        <Badge badgeContent={newsCount} color="error">*/}
            {/*            <FeedIcon sx={buttonIconStyle}/>*/}
            {/*        </Badge> : <FeedIcon sx={buttonIconStyle}/>*/}
            {/*    }*/}
            {/*    <h5 style={buttonTextStyle}>News</h5>*/}
            {/*</IconButton>*/}
            <IconButton
              edge="start"
              color="inherit"
              aria-label="projects"
              onClick={openProjects}
            >
              <LibraryIcon sx={buttonIconStyle} />{" "}
              <h5 style={buttonTextStyle}>4RF Projects</h5>
            </IconButton>
            <IconButton
              edge="start"
              color="inherit"
              aria-label="projects"
              onClick={openPSDPProjects}
            >
              <LibraryIcon sx={buttonIconStyle} />{" "}
              <h5 style={buttonTextStyle}>PSDP Projects</h5>
            </IconButton>
            <IconButton
              edge="start"
              color="inherit"
              aria-label="ppp-projects"
              onClick={openPPPProjects}
            >
              <LibraryIcon sx={buttonIconStyle} />{" "}
              <h5 style={buttonTextStyle}>PPP Projects</h5>
            </IconButton>
            <ADPMenuButton onProvinceSelect={(p) => openADPProjects(p)} />
            <IconButton
              edge="start"
              color="inherit"
              aria-label="pledge info"
              onClick={openPledgeStatus}
            >
              <LibraryIcon sx={buttonIconStyle} />{" "}
              <h5 style={buttonTextStyle}>Pledge Status</h5>
            </IconButton>
            <IconButton
              edge="start"
              color="inherit"
              aria-label="projects"
              onClick={compareStatsDrawer}
            >
              <CompareArrowsIcon sx={buttonIconStyle} />
              <h5 style={buttonTextStyle}>Compare Stats</h5>
            </IconButton>
            <ManageControl
              iconStyle={buttonIconStyle}
              buttonTextStyle={buttonTextStyle}
            />
          </Toolbar>
        </div>
        <div ref={bar2Ref} className="container-fluid subhdr1">
          <div
            className="row"
            style={{
              background:
                "linear-gradient( 180deg, rgb(15.94, 127.5, 40.48) 0%, rgb(40.16, 172.13, 69.19) 100% )",
            }}
          >
            <div className="col-md-6 pr-0 mr-0">
              {/*<h5 className="text-white text-uppercase pb-0 mt-1 mb-1">*/}
              <Button
                variant="text"
                style={{
                  color: "white",
                  fontSize: "1em",
                  whiteSpace: "nowrap",
                }}
                onClick={() => {
                  dialogBoxRef?.current?.setContent(
                    <>
                      <SROTabs />
                    </>,
                  );
                  dialogBoxRef?.current?.openDialog(
                    "Strategic Recovery Objective (SRO)",
                  );
                }}
              >
                Resilient Recovery, Rehabilitation, and Reconstruction Framework
                (4RF)
              </Button>
              {/*</h5>*/}
            </div>
            <div className="col-md-2  ml-0 mt-1 mb-1 mr-0 pl-2" />
            <div
              className="col-md-2 bg-light text-center rounded ml-0 mt-1 mb-1 mr-0 "
              style={{
                background:
                  "linear-gradient( 180deg, rgb(255, 255, 255) 0%, rgba(243.31, 243.31, 243.31, 0.85) 100% )",
                borderRadius: "8px 8px 0px 0px",
                height: "35px",
                color: "black !important",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                alignContent: "center",
              }}
            >
              <DocumentMenu />
            </div>
            <div
              className="col-md-2 bg-light text-center rounded ml-0 mt-1 mb-1 mr-0"
              style={{
                background:
                  "linear-gradient( 180deg, rgb(255, 255, 255) 0%, rgba(243.31, 243.31, 243.31, 0.85) 100% )",
                borderRadius: "8px 8px 0px 0px",
                height: "35px",
                color: "black !important",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                alignContent: "center",
              }}
            >
              <h5
                className="mb-0 pt-0"
                id={"updated-date"}
                style={{
                  color: "black",
                  fontWeight: 300,
                  whiteSpace: "nowrap",
                }}
              >
                {lastUpdateOn}
              </h5>
            </div>
          </div>
        </div>
      </AppBar>
      <TopDrawer />
    </>
  );
};
export default TopAppbar;

// const mapDispatchToProps = (dispatch: any) => {
//     return {
//         setTopAppbarHeight: (th: number) => dispatch(baseActions.setTopAppbarHeight(th)),
//     }
// }
//
//
// export default connect(null, mapDispatchToProps)(TopAppbar);
